export class HardwareSensor{
  constructor(
    public hardwareSensorId: string,
    public sergasCode: string,
    public serialNumber: string,
    public calibrationDate: Date,
    public certifier: string,
    public certificationUrl: string,
    public installedDate: Date,
    public created: Date,
    public createdBy: string,
    public modified: Date,
    public modifiedBy: string,
    public sergasDeviceSensorId: string
  ){}
}
